import { render, staticRenderFns } from "./ODTF.vue?vue&type=template&id=8faa115e&scoped=true&"
import script from "./ODTF.vue?vue&type=script&lang=js&"
export * from "./ODTF.vue?vue&type=script&lang=js&"
import style0 from "./ODTF.vue?vue&type=style&index=0&id=8faa115e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa115e",
  null
  
)

export default component.exports